import { useEffect, useState } from 'react';
import { Element, scroller } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import Section from './Section';
import ContactForm from './ContactForm';
import './Connect.css';

const socialLinks = [
  {
    href: 'https://www.linkedin.com/in/smallphish',
    label: 'Adam on LinkedIn',
    icon: faLinkedin,
  },
  {
    href: 'https://github.com/smallosaurus',
    label: 'Adam on GitHub',
    icon: faGithub,
  },
];

function Connect() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    if (isFormOpen) {
      scroller.scrollTo('contact-form', {
        smooth: true,
        duration: 500,
        offset: -64,
      });
    }
  }, [isFormOpen]);

  return (
    <Section name="connect" title="Let's Connect" tone="base">
      <p className="connect__lead">
        Got a problem worth solving, or just want to talk shop? The pond's
        always open.
      </p>
      <ul className="connect__links">
        <li>
          <button
            type="button"
            className="connect__link"
            aria-label="Email Adam"
            aria-expanded={isFormOpen}
            aria-controls="contact-form"
            onClick={() => setIsFormOpen((open) => !open)}
          >
            <FontAwesomeIcon icon={faEnvelope} size="2x" aria-hidden="true" />
          </button>
        </li>
        {socialLinks.map(({ href, label, icon }) => (
          <li key={label}>
            <a
              href={href}
              className="connect__link"
              aria-label={label}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={icon} size="2x" aria-hidden="true" />
            </a>
          </li>
        ))}
      </ul>
      {isFormOpen && (
        <Element name="contact-form">
          <ContactForm id="contact-form" />
        </Element>
      )}
      <p className="connect__footnote">
        Made with <span aria-hidden="true">🐟</span> by the Smallphish
      </p>
    </Section>
  );
}

export default Connect;
